import _typeof from "@babel/runtime/helpers/typeof";

/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
import React from 'react';
import createChainableTypeChecker from './utils/createChainableTypeChecker';

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  var propType = _typeof(propValue);

  if ( /*#__PURE__*/React.isValidElement(propValue)) {
    return new Error("Invalid ".concat(location, " `").concat(propFullName, "` of type ReactElement ") + "supplied to `".concat(componentName, "`, expected an element type (a string ") + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error("Invalid ".concat(location, " `").concat(propFullName, "` of value `").concat(propValue, "` ") + "supplied to `".concat(componentName, "`, expected an element type (a string ") + 'or a ReactClass).');
  }

  return null;
}

export default createChainableTypeChecker(elementType);


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/elementType.js